import { Extension } from '@tiptap/core';
import { Plugin, PluginKey } from '@tiptap/pm/state';
/**
 * This extension allows you to count the characters and words of your document.
 * @see https://tiptap.dev/api/extensions/character-count
 */

var CharacterCount = Extension.create({
  name: 'characterCount',
  addOptions: function addOptions() {
    return {
      limit: null,
      mode: 'textSize',
      textCounter: function textCounter(text) {
        return text.length;
      },
      wordCounter: function wordCounter(text) {
        return text.split(' ').filter(function (word) {
          return word !== '';
        }).length;
      }
    };
  },
  addStorage: function addStorage() {
    return {
      characters: function characters() {
        return 0;
      },
      words: function words() {
        return 0;
      }
    };
  },
  onBeforeCreate: function onBeforeCreate() {
    var _this = this;

    this.storage.characters = function (options) {
      var node = (options === null || options === void 0 ? void 0 : options.node) || _this.editor.state.doc;
      var mode = (options === null || options === void 0 ? void 0 : options.mode) || _this.options.mode;

      if (mode === 'textSize') {
        var text = node.textBetween(0, node.content.size, undefined, ' ');
        return _this.options.textCounter(text);
      }

      return node.nodeSize;
    };

    this.storage.words = function (options) {
      var node = (options === null || options === void 0 ? void 0 : options.node) || _this.editor.state.doc;
      var text = node.textBetween(0, node.content.size, ' ', ' ');
      return _this.options.wordCounter(text);
    };
  },
  addProseMirrorPlugins: function addProseMirrorPlugins() {
    var _this2 = this;

    var initialEvaluationDone = false;
    return [new Plugin({
      key: new PluginKey('characterCount'),
      appendTransaction: function appendTransaction(transactions, oldState, newState) {
        if (initialEvaluationDone) {
          return;
        }

        var limit = _this2.options.limit;

        if (limit === null || limit === undefined || limit === 0) {
          initialEvaluationDone = true;
          return;
        }

        var initialContentSize = _this2.storage.characters({
          node: newState.doc
        });

        if (initialContentSize > limit) {
          var over = initialContentSize - limit;
          var from = 0;
          var to = over;
          console.warn("[CharacterCount] Initial content exceeded limit of ".concat(limit, " characters. Content was automatically trimmed."));
          var tr = newState.tr.deleteRange(from, to);
          initialEvaluationDone = true;
          return tr;
        }

        initialEvaluationDone = true;
      },
      filterTransaction: function filterTransaction(transaction, state) {
        var limit = _this2.options.limit; // Nothing has changed or no limit is defined. Ignore it.

        if (!transaction.docChanged || limit === 0 || limit === null || limit === undefined) {
          return true;
        }

        var oldSize = _this2.storage.characters({
          node: state.doc
        });

        var newSize = _this2.storage.characters({
          node: transaction.doc
        }); // Everything is in the limit. Good.


        if (newSize <= limit) {
          return true;
        } // The limit has already been exceeded but will be reduced.


        if (oldSize > limit && newSize > limit && newSize <= oldSize) {
          return true;
        } // The limit has already been exceeded and will be increased further.


        if (oldSize > limit && newSize > limit && newSize > oldSize) {
          return false;
        }

        var isPaste = transaction.getMeta('paste'); // Block all exceeding transactions that were not pasted.

        if (!isPaste) {
          return false;
        } // For pasted content, we try to remove the exceeding content.


        var pos = transaction.selection.$head.pos;
        var over = newSize - limit;
        var from = pos - over;
        var to = pos; // It’s probably a bad idea to mutate transactions within `filterTransaction`
        // but for now this is working fine.

        transaction.deleteRange(from, to); // In some situations, the limit will continue to be exceeded after trimming.
        // This happens e.g. when truncating within a complex node (e.g. table)
        // and ProseMirror has to close this node again.
        // If this is the case, we prevent the transaction completely.

        var updatedSize = _this2.storage.characters({
          node: transaction.doc
        });

        if (updatedSize > limit) {
          return false;
        }

        return true;
      }
    })];
  }
});
export { CharacterCount, CharacterCount as default };